import { SummarySection } from "../types/ContentTypes";

/**
 * Split HTML content into multiple parts by H2 tags
 */
export function splitHtmlByH2(htmlContent: string): SummarySection[] {
    if (!htmlContent) {
        return [];
    }
    const h2Regex = /<h2[^>]*>\s*<strong[^>]*>\s*(.*?)\s*<\/strong>\s*<\/h2>/gs;
    const result = [];
    const h2Matches = [];
    let match;

    while ((match = h2Regex.exec(htmlContent)) !== null) {
        h2Matches.push({
            index: match.index,
            content: match[0],
            title: match[1].trim(),
            fullMatch: match[0],
        });
    }

    if (h2Matches.length === 0) {
        return [
            {
                key: "content",
                value: htmlContent.trim(),
            },
        ];
    }

    for (let i = 0; i < h2Matches.length; i++) {
        const currentMatch = h2Matches[i];
        const nextMatch = h2Matches[i + 1];
        const startIndex = currentMatch.index;
        const endIndex = nextMatch ? nextMatch.index : htmlContent.length;
        let content = htmlContent.substring(startIndex, endIndex).trim();

        if (!content || !currentMatch.title) {
            continue;
        }
        content = content.replace(/\s+/g, " ").trim();
        result.push({
            key: currentMatch.title,
            value: content,
        });
    }
    return result;
}
